import { createContext } from "react";
import { z } from "zod";

type ThemeContextProps = {
	themeMode: ThemeMode;
	resolvedTheme: ResolvedTheme;
	setTheme: (theme: ThemeMode) => void;
	toggleMode: () => void;
};

export const ThemeContext = createContext<ThemeContextProps | undefined>(undefined);

export const themeModeSchema = z.enum(["light", "dark", "system"]);
export const resolvedThemeSchema = z.enum(["light", "dark"]);
export const themeKey = "theme";

export type ThemeMode = z.infer<typeof themeModeSchema>;
export type ResolvedTheme = z.infer<typeof resolvedThemeSchema>;
